export default function getTenantId() {
  let hostName = window.location.hostname.toLowerCase();
  if (hostName.startsWith("nj")) {
    return "nj";
  } else {
    return "illinois";
  }
}
